<template>
  <div>
    <base-header
      type="gradient-success"
      class="pb-6 pb-8 pt-5 pt-md-8"
    ></base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <ayahs-table
            :title="surahData && surahData.czechTrans + ' ' + 'Verses'"
            :ayahs="ayahs"
            :surahId="surahId"
            :page="page"
            :perPage="perPage"
            :total="totalAyahs"
            :seeAll="seeAll"
            @pageChange="pageChange"
            @seeAllToggle="seeAllToggle"
          ></ayahs-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AyahsTable from "./Tables/AyahsTable";

import * as api from "@/apiList";
export default {
  name: "ayahs",
  components: {
    AyahsTable,
  },
  data() {
    return {
      surahId: this.$route.params.id,
      surahData: {},
      ayahs:
        (JSON.parse(localStorage.getItem("ayahs")) &&
          JSON.parse(localStorage.getItem("ayahs"))[this.$route.params.id]) ||
        [],
      totalAyahs: 0,

      filter: null,
      keyword: null,

      page: 1,
      perPage: 10,

      seeAll: false,
    };
  },
  methods: {
    async getAyahs() {
      this.$store.dispatch("toggleLoader", true);
      if (!this.seeAll) {
        this.perPage = 10;
      }
      let query = !this.seeAll && `page=${this.page}&perPage=${this.perPage}`;
      query = this.surahId + "?" + query;
      let getRes = await api.getAyahs(query);
      if (getRes.status == 200) {
        this.ayahs = getRes.data.data.ayahs;
        this.totalAyahs = getRes.data.data.total;
        let localAyahs = JSON.parse(localStorage.getItem("ayahs"));
        if (localAyahs) {
          localAyahs[this.surahId] = this.ayahs;
          localStorage.setItem("ayahs", JSON.stringify(localAyahs));
        } else {
          let localAyahs = {};
          localAyahs[this.surahId] = this.ayahs;
          localStorage.setItem("ayahs", JSON.stringify(localAyahs));
        }
        if (this.seeAll) {
          this.perPage = this.totalAyahs;
        }
      }
      this.$store.dispatch("toggleLoader", false);
    },
    async pageChange(pageNo) {
      this.page = pageNo;
      this.getAyahs();
    },
    async seeAllToggle() {
      this.page = 1;
      this.seeAll = !this.seeAll;
      this.getAyahs();
    },

    async getSurahData() {
      let surahData = await api.getSurah(this.surahId);
      if (surahData.status == 200) {
        this.surahData = surahData.data.data;
      }
    }
  },
  created() {
    this.surahId = this.$route.params.id;
    this.getAyahs();
    this.getSurahData();
  },
  mounted() {},
};
</script>
<style></style>
